import {useAppState} from "@/store";
import {useRef} from "react";

export default function Panel({children, className, passive, feature}) {
    const {state, setState} = useAppState()
    const el = useRef(null)
    const setFocus = () => {
        if (passive) {
            return
        }
        setState((s) => {
            s.focusedEl = el.current
        })
    }

    const focused = !!(el.current && state.focusedEl && el.current.isEqualNode(state.focusedEl))
    
    return (
        <div ref={el} className={"ein-panel " + (focused ? 'ein-panel-focused' : '') + (feature ? ' ein-panel-gradient !border-2 !border-brand-orange' : '') + (className ? ` ${className}` : '')} onClick={setFocus}>
            {children}
        </div>
    )
}
